import "./searchForm.css";

const SearchForm = ({ setFilters }) => {
    return (
        <section className="search-form-holder">
            <div className="container">
                <div className="form-wrapper">
                    <h3>Search what you are looking for.</h3>
                    <form className="search-form d-flex align-items-center justify-content-between" action="" method="post">
                        <div className="form-group full-w applyPd">
                            <input type="text" className="form-control field-des" placeholder="Search 2172 items" />
                        </div>
                        <div className="form-group d-flex align-items-center custom-w applyPd">
                            <span className="input-group-addon">
                                <img alt="" src={require("../../../assets/images/category.png").default} className="img-fluid" />
                            </span>
                            <select id="categories" name="categories" className="field-des " form="categoriesform" onChange={(event) => {
                                const value = event.target.value;
                                setFilters(value !== "All" ? { category: value } : undefined)
                            }}>
                                <option value="All">All categories</option>
                                <option value="1">category 1</option>
                                <option value="2">category 2</option>
                            </select>
                        </div>
                        <div className="form-group d-flex align-items-center custom-w applyPd">
                            <span className="input-group-addon">
                                <img alt="" src={require("../../../assets/images/pin.png").default} className="img-fluid" />
                            </span>
                            <select id="location" name="locations" className="field-des" form="locationform">
                                <option value="">All Locations</option>
                                <option value="">location 1</option>
                                <option value="">location 2</option>
                            </select>
                        </div>
                        <div className="form-group d-flex align-items-center custom-w applyPd">
                            <span className="input-group-addon">
                                <img alt="" src={require("../../../assets/images/arrows.png").default} className="img-fluid" />
                            </span>
                            <select id="distance" name="distance" className="field-des" form="distanceform">
                                <option value="">100kms</option>
                                <option value="">80kms </option>
                                <option value="">70kms</option>
                            </select>
                        </div>
                        <div className="btn-wrapper custom-w">
                            <button type="button" className="btn btn-custom">Search</button>
                        </div>
                    </form>
                </div>
            </div>
        </section>
    );
}

export default SearchForm;